import { ProjectsFilterBuilder } from '@/shared/filters/entity-filters/project-filter-builder/project-filter-builder';
import { devicesApi } from '@/shared/redux/api/assets/devices/devices-api';
import { groupsApi } from '@/shared/redux/api/assets/groups/groups-api';
import { projectsApi } from '@/shared/redux/api/assets/projects/projects-api';
import { jobsApi } from '@/shared/redux/api/jobs/jobs-api';
import store from '@/shared/redux/store/store';
import {
  PaginationInput,
  ProjectTypeEnum,
} from '@/shared/types/types.generated';

const HOME_CARD_PAGINATION: PaginationInput = {
  page: 1,
  pageSize: 15,
};

export const prefetchHomeCards = () => {
  const projectFilter = new ProjectsFilterBuilder()
    .applyFilter('projectType', ProjectTypeEnum.Standard)
    .build();

  store.dispatch(
    groupsApi.util.prefetch(
      'ReadAllResourceGroups',
      {
        pagination: HOME_CARD_PAGINATION,
        filter: undefined,
      },
      { ifOlderThan: 60 },
    ),
  );

  store.dispatch(
    projectsApi.util.prefetch(
      'ReadAllProjects',
      {
        filter: projectFilter,
        pagination: HOME_CARD_PAGINATION,
      },
      { ifOlderThan: 60 },
    ),
  );

  store.dispatch(
    devicesApi.util.prefetch(
      'ReadDevicesForList',
      {
        pagination: HOME_CARD_PAGINATION,
      },
      { ifOlderThan: 60 },
    ),
  );

  store.dispatch(
    jobsApi.util.prefetch(
      'ReadAllPipelines',
      {
        pagination: HOME_CARD_PAGINATION,
      },
      { ifOlderThan: 60 },
    ),
  );
};
